

import React, { Component } from "react";
import { withRouter } from "./withRouter";
import  {  Popup } from "react-map-gl";

const PARTY_INFO = {
  inflation_issue_n: { name: "Inflation", color: "#D98A36" },      // muted orange
  health_issue_n: { name: "Health", color: "#C23B72" },            // deep rose
  econ_issue_n: { name: "Economy", color: "#2A9FD6" },             // calm blue
  crime_issue_n: { name: "Crime", color: "#8253C8" },              // softer purple
  housing_issue_n: { name: "Housing", color: "#CC7046" },          // warm terracotta
  poverty_issue_n: { name: "Poverty", color: "#CC3333" },          // darker red
  unemployment_issue_n: { name: "Unemployment", color: "#CCB830" },// muted mustard
  climate_issue_n: { name: "Climate", color: "#2BA84A" },          // medium green
  education_issue_issue_n: { name: "Education", color: "#2B78E4" },// standard professional blue
  transport_issue_n: { name: "Transport", color: "#D1691F" },      // darker tangerine
  drugs_issue_n: { name: "Drugs", color: "#A6A832" },              // olive green
  race_rel_issue_n: { name: "Race relations", color: "#1EB7B7" },  // teal
  tax_issue_n: { name: "Tax", color: "#B94D4D" },                  // muted coral
  pollution_issue_n: { name: "Pollution", color: "#707070" },      // medium grey
  maori_issue_n: { name: "Māori", color: "#9C3E1D" },              // earthy rust
  immigration_issue_n: { name: "Immigration", color: "#C4A22E" },  // subdued gold
  defence_issue_n: { name: "Defence", color: "#335CBA" }           // classic navy blue
};


// Build labels and colors in one go
const buildLabelsAndColors = () => {
  const labels = {};
  const colors = {};

  Object.entries(PARTY_INFO).forEach(([key, info]) => {
    labels[key] = info.name;
    colors[key] = info.color;
  });

  return { labels, colors };
};


const clamp01 = (x) => Math.max(0, Math.min(1, x));
const hexToHsl = (hex) => {
  let c = hex.replace("#",""); if (c.length===3) c = c.split("").map(x=>x+x).join("");
  const r=parseInt(c.slice(0,2),16)/255, g=parseInt(c.slice(2,4),16)/255, b=parseInt(c.slice(4,6),16)/255;
  const max=Math.max(r,g,b), min=Math.min(r,g,b); let h,s,l=(max+min)/2;
  if(max===min){h=s=0;} else {const d=max-min; s=l>0.5?d/(2-max-min):d/(max+min);
    switch(max){
    case r:h=(g-b)/d+(g<b?6:0);
      break;
    case g:h=(b-r)/d+2;
      break;
    case b:h=(r-g)/d+4;
      break;
    default:
      break;
    } h/=6;}
  return {h:Math.round(h*360), s:Math.round(s*100), l:Math.round(l*100)};
};
const hslToHex = (h,s,l) => {
  h/=360; s/=100; l/=100;
  const hue2rgb=(p,q,t)=>{ if(t<0)t+=1;if(t>1)t-=1;if(t<1/6)return p+(q-p)*6*t;if(t<1/2)return q;if(t<2/3)return p+(q-p)*(2/3-t)*6;return p; };
  const q=l<0.5?l*(1+s):l+s-l*s; const p=2*l-q;
  const r=Math.round(hue2rgb(p,q,h+1/3)*255), g=Math.round(hue2rgb(p,q,h)*255), b=Math.round(hue2rgb(p,q,h-1/3)*255);
  return "#"+[r,g,b].map(v=>v.toString(16).padStart(2,"0")).join("");
};
const makeHeatScale = (baseHex, values) => {
  const finite = values.filter(v => Number.isFinite(v));
  const min = finite.length ? Math.min(...finite) : 0;
  const max = finite.length ? Math.max(...finite) : 100;
  const { h, s } = hexToHsl(baseHex);
  return (v) => {
    if (!Number.isFinite(v)) return "#CCCCCC";
    const t = clamp01((v - min) / Math.max(1e-6, max - min));
    const light = 95 - t * 60; // light → dark
    return hslToHex(h, s, light);
  };
};



class TooltipInternalMainMap extends Component {
 
  
             
buildTooltip(hoverInfo, styledGeo) {
  const { geoLevel } = this.props;
  if (!hoverInfo || !styledGeo) return null;

  const { area_name, _allValuesSorted } = hoverInfo.props;

  // Map level label
  let area_type_label;
  switch (geoLevel) {
    case "constituency":
      area_type_label = "Electorate";
      break;
    default:
      area_type_label = geoLevel;
      break;
  }

  // Parse and select top 3
  let topIssues = [];
  try {
    const parsed = JSON.parse(_allValuesSorted);
    topIssues = parsed.slice(0, 3);
  } catch (e) {
    console.warn("Could not parse _allValuesSorted:", e);
  }

  // Colour lookup
  const { colors } = buildLabelsAndColors();

  // Tooltip container
  return (
    <div
      style={{
        fontSize: "12px",
        background: "rgba(255,255,255,0.95)",
        borderRadius: "6px",
        padding: "6px 8px",
        boxShadow: "0 0 6px rgba(0,0,0,0.15)",
        maxWidth: "180px",
      }}
    >
      <strong>{area_name}</strong> {area_type_label}
      <div style={{ marginTop: 6 }}>
        {topIssues.length > 0 ? (
          topIssues.map((issue, i) => {
            const colour = colors[issue.key] || "#888";
            const value = Number(issue.area_id) || 0;
            return (
              <div key={i} style={{ marginBottom: 4 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontWeight: 500,
                    marginBottom: 2,
                  }}
                >
                  <span>{issue.area_name}</span>
                  <span>{value.toFixed(1)}%</span>
                </div>
                <div
                  style={{
                    height: "6px",
                    background: "#e0e0e0",
                    borderRadius: "3px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      width: `${value}%`,
                      background: colour,
                      height: "100%",
                      borderRadius: "3px",
                    }}
                  />
                </div>
              </div>
            );
          })
        ) : (
          <span>No issue data</span>
        )}
      </div>
    </div>
  );
}








 

  render() {    
    const {  styledGeo,  hoverInfo} = this.props;

   
  return (
    <>
      {styledGeo && hoverInfo && hoverInfo?.props?.topValue>0 &&(
        <Popup
          longitude={hoverInfo.lon}
          latitude={hoverInfo.lat}
          closeButton={false}
          closeOnClick={false}
          offset={12}
          dynamicPosition={true}
          maxWidth="500px"
  className="no-popup-frame"  // 👈 add this
        >
          {this.buildTooltip(hoverInfo, styledGeo, this.props.tooltip_pastcomp)}
        </Popup>
      )}
    </>
  );
}
}
    
    export default withRouter(TooltipInternalMainMap);
    